<template>
  <div class="acaEdu">
    <div class="g-box">
      <div class="acaEdu-search">
        <div class="acaEdu-search-group tab">
          <div class="acaEdu-search-item">
            <div class="cap">全部结果</div>
            <div class="cont">
              <div class="list-tab">
                成人教育
                <div class="close m-h"></div>
              </div>
              <div class="list-tab">
                成人教育
                <div class="close m-h"></div>
              </div>
              <div class="list-tab">
                成人教育
                <div class="close m-h"></div>
              </div>
              <div class="list-tab">
                成人教育
                <div class="close m-h"></div>
              </div>
              <div class="list-tab">
                成人教育
                <div class="close m-h"></div>
              </div>
              <div class="list-tab">
                成人教育
                <div class="close m-h"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="acaEdu-search-group">
          <div class="acaEdu-search-item">
            <div class="cap">学历教育</div>
            <div class="cont">
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
            </div>
          </div>
          <div class="acaEdu-search-item">
            <div class="cap">学历教育</div>
            <div class="cont">
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
            </div>
          </div>
          <div class="acaEdu-search-item">
            <div class="cap">学历教育</div>
            <div class="cont">
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
              <div class="list-item m-h">全部</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="acaEdu-hr"></div>
    <div class="g-box">
      <div class="acaEdu-list">
        <router-link to="/" class="list-item m-h">
          <div
            class="list-item-img"
            :style="{
              backgroundImage:
                'url(' + require('../../assets/img/ico_5.jpg') + ')'
            }"
          ></div>
          <div class="list-item-cap">西北师范大学</div>
        </router-link>
        <router-link to="/" class="list-item m-h">
          <div
            class="list-item-img"
            :style="{
              backgroundImage:
                'url(' + require('../../assets/img/ico_5.jpg') + ')'
            }"
          ></div>
          <div class="list-item-cap">西北师范大学</div>
        </router-link>
        <router-link to="/" class="list-item m-h">
          <div
            class="list-item-img"
            :style="{
              backgroundImage:
                'url(' + require('../../assets/img/ico_5.jpg') + ')'
            }"
          ></div>
          <div class="list-item-cap">西北师范大学</div>
        </router-link>
        <router-link to="/" class="list-item m-h">
          <div
            class="list-item-img"
            :style="{
              backgroundImage:
                'url(' + require('../../assets/img/ico_5.jpg') + ')'
            }"
          ></div>
          <div class="list-item-cap">西北师范大学</div>
        </router-link>
        <router-link to="/" class="list-item m-h">
          <div
            class="list-item-img"
            :style="{
              backgroundImage:
                'url(' + require('../../assets/img/ico_5.jpg') + ')'
            }"
          ></div>
          <div class="list-item-cap">西北师范大学</div>
        </router-link>
        <router-link to="/" class="list-item m-h">
          <div
            class="list-item-img"
            :style="{
              backgroundImage:
                'url(' + require('../../assets/img/ico_5.jpg') + ')'
            }"
          ></div>
          <div class="list-item-cap">西北师范大学</div>
        </router-link>
        <router-link to="/" class="list-item m-h">
          <div
            class="list-item-img"
            :style="{
              backgroundImage:
                'url(' + require('../../assets/img/ico_5.jpg') + ')'
            }"
          ></div>
          <div class="list-item-cap">西北师范大学</div>
        </router-link>
        <router-link to="/" class="list-item m-h">
          <div
            class="list-item-img"
            :style="{
              backgroundImage:
                'url(' + require('../../assets/img/ico_5.jpg') + ')'
            }"
          ></div>
          <div class="list-item-cap">西北师范大学</div>
        </router-link>
      </div>
      <el-pagination
        @current-change="onCurrentChange"
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        :page-size="pageSize"
        :total="total"
        class="m-pagination"
      />
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {};
  },
  components: {},
  mounted() {},
  methods: {}
};
</script>
<style lang="less">
.acaEdu {
  padding: 110px 0;
}
.acaEdu-search {
  border: 1px solid rgba(225, 225, 225, 1);
  margin-bottom: 54px;
}
.acaEdu-search-group {
  padding: 20px 0;
  & + .acaEdu-search-group {
    border-top: 1px solid #f0f0f0;
  }
  &.tab {
    .cont {
      margin-top: -7px;
    }
  }
}
.acaEdu-search-item {
  padding: 12px 30px 2px 30px;
  display: flex;
  .cap {
    color: #979797;
    font-size: 16px;
    flex-shrink: 0;
    width: 80px;
  }
  .cont {
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    margin-left: 20px;
  }
  .list-tab {
    color: #606060;
    font-size: 16px;
    border: 1px solid rgba(225, 225, 225, 1);
    padding: 5px 8px;
    line-height: 1;
    display: flex;
    align-items: center;
    margin-right: 24px;
    margin-bottom: 10px;
    .close {
      background: url("../../assets/img/ico_25.png") no-repeat;
      width: 18px;
      height: 18px;
      margin-left: 10px;
    }
  }
  .list-item {
    color: #606060;
    font-size: 16px;
    margin-right: 24px;
    margin-bottom: 10px;
    &:hover {
      color: #5297e0;
    }
  }
}
.acaEdu-hr {
  height: 16px;
  background: rgba(242, 243, 247, 1);
}
.acaEdu-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 56px;
  .list-item {
    display: block;
    width: 260px;
    height: 237px;
    border-radius: 6px;
    border: 1px solid rgba(232, 232, 232, 1);
    margin-bottom: 30px;
    margin-right: 50px;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  .list-item-img {
    width: 248px;
    height: 158px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    margin: 6px auto 0 auto;
  }
  .list-item-cap {
    color: #606060;
    font-size: 18px;
    margin: 24px 6px 0 6px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
